import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { AppSettings, AttendanceRegularization, Employee } from 'service/Models';
import ServerGateway from 'service/ServerGateway';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard, faClock } from '@fortawesome/free-solid-svg-icons';
import SettingsService from 'service/SettingsService';
import toast, { Toaster } from 'react-hot-toast';

export const Attendance = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [settings, setSettings] = useState<AppSettings>();

    useEffect(() => {
        SettingsService.get()
            .then((data) => {
                setSettings(data);
            });
    }, []);

    return (
        <div className="page-attendance">
            {settings?.markAttendance && (
                <div className='row my-2'>
                    <div className='col-md-12'>
                        <NavLink to="/attendance/punch" className='btn bg-success w-100 text-white'>
                            <FontAwesomeIcon icon={faClock} className="me-2" />
                            Mark Attendance
                        </NavLink>
                    </div>
                </div>
            )}
            
            <div className='row my-2'>
                <div className='col-md-12'>
                    <NavLink to="/attendance/report" className='btn bg-success w-100 text-white'>
                        <FontAwesomeIcon icon={faClipboard} className="me-2" />
                        View Attendance Report    
                    </NavLink>
                </div>
            </div>
        </div>
    );
}